module.exports = __webpack_public_path__ + "img/2581741-18-4.73ea36dd.png";